// src/components/sections/HomeFeatures/HomeFeaturesSection.jsx
import React, { useState } from "react";
import { Container, Row, Col, Tabs, Tab } from "react-bootstrap";
import SectionTitle from "../../../common/SectionTitle/SectionTitle";
import HomeFeatureTab from "../HomeFeatureTab/HomeFeatureTab";
import homeFeaturesData from "../../../../data/homeFeaturesData";
import "./HomeFeaturesSection.css";

export default function HomeFeaturesSection() {
  const [activeKey, setActiveKey] = useState(homeFeaturesData[0].id);

  return (
    <section className="home-features-section section-spacing">
      <Container fluid>
        <div className="text-center">
          <SectionTitle
            subtitle="Technology"
            title="That Powers Every Journey"
          />
        </div>

        <p class="brand-section-desc text-center mb-0">At LANDKING, technology isn’t just an addition  it’s the foundation of every truck we build.</p>

      <p class="brand-section-desc text-center">Each model is engineered with cutting-edge innovation, designed to deliver efficiency, safety, 
          and control that meet the demands of modern businesses in the Kingdom of Saudi Arabia.</p>
        <Row>
          <Col lg={12}>
            <Tabs
              id="home-features-tabs"
              activeKey={activeKey}
              onSelect={(k) => setActiveKey(k)}
              className="home-features-tabs"
              justify
            >
              {homeFeaturesData.map((feature) => (
                <Tab
                  key={feature.id}
                  eventKey={feature.id}
                  title={feature.title}
                  tabClassName="home-features-tab-title"
                >
                  <div className="home-features-tab-content">
                    <HomeFeatureTab
                      imageSrc={feature.imageSrc}
                      title={feature.title}
                      description={feature.description}
                    />
                  </div>
                </Tab>
              ))}
            </Tabs>
          </Col>
        </Row>
      </Container>
    </section>
  );
}
